module.exports = __webpack_public_path__ + "static/media/16_a_1.8bf6384a.png";